import React, { useEffect, useState } from "react"
import { navigate } from "gatsby"
import { Col } from "react-bootstrap"
import "./SearchResultsPagination.scss"

function SearchResultsPagination(props) {
  // console.log("location_state ==>", props)

  const {
    locationPath,
    currentPageNumber,
    tag,
    total,
    nbPages,
    page_url_data,
  } = props

  const [pageNumber, setPageNumber] = useState(
    parseInt(page_url_data?.pageVal, 10) || 1,
  )

  const scrollTop = () => {
    setTimeout(() => {
      window.scrollTo(0, 0)
    }, 1000)
  }

  useEffect(() => {
    scrollTop()
  }, [])

  const changepagination = (event) => {
    // get sortby value
    let pageUrl = ""
    setPageNumber(parseInt(event.target.value, 10))
    if (event?.target.value && event?.target.value > 1) {
      pageUrl = `page-${event?.target.value}/`
    }
    // get current url
    const urlwithoutsort = locationPath.split("page-")

    // console.log("urlwithoutsort", urlwithoutsort[0].endsWith("/"))
    if (urlwithoutsort[0].endsWith("/")) {
      navigate(`${urlwithoutsort[0]}${pageUrl}`)
    } else {
      navigate(`${urlwithoutsort[0]}/${pageUrl}`)
    }
    // concat url and navigate
    scrollTop()
  }

  const nextpage = () => {
    setPageNumber(pageNumber + 1)
    const pageUrl = `page-${pageNumber + 1}/`
    // get current url

    const urlwithoutsort = locationPath.split("page-")

    // concat url and navigate
    if (urlwithoutsort[0].endsWith("/")) {
      navigate(`${urlwithoutsort[0]}${pageUrl}`)
    } else {
      navigate(`${urlwithoutsort[0]}/${pageUrl}`)
    }

    scrollTop()
  }

  const prevpage = () => {
    if (pageNumber > 1) {
      setPageNumber(pageNumber - 1)
    }
    let pageUrl = `page-${pageNumber - 1}/`
    if (pageUrl === "page-1/" || pageUrl === "page-0/") {
      pageUrl = ""
    }
    // get current url
    const urlwithoutsort = locationPath.split("page-")
    // concat url and navigate
    if (urlwithoutsort[0].endsWith("/")) {
      navigate(`${urlwithoutsort[0]}${pageUrl}`)
    } else {
      navigate(`${urlwithoutsort[0]}/${pageUrl}`)
    }

    scrollTop()
  }
  //
  const pageOptions = []
  for (let i = 1; i <= nbPages; i++) {
    pageOptions.push({ value: i, label: i })
  }
  // props?.page_url_data?.pageVal
  //   const page_key = Object.keys(pageOptions).find(
  //     (key) => pageOptions[key].value === props?.page_url_data?.pageVal,
  //   )

  return (
    <div className={`load-more-wrap ${tag}`}>
      {total && (
        <div className="d-flex align-items-center justify-content-between">
          <button
            className={`results-btn d-flex align-items-center ${
              currentPageNumber > 0 ? "" : "disabled"
            }`}
            disabled={currentPageNumber > 0 ? "" : "disabled"}
            onClick={() => prevpage()}
          >
            <i className="icon icon-back" /> <span>Back</span>
          </button>

          {/* <div className="text-center pages-count d-flex align-items-center">
                        <div className="spacing spacing-right">Page</div>
                        <Select
                            options={pageOptions}
                            onChange={changepagination}
                            placeholder={(props?.current_page_number) + 1}
                            className={"select-control"}
                            classNamePrefix={"react-select"}
                            //styles={customStyles}
                            defaultValue={pageOptions[page_key]}
                            value={pageOptions.value}
                            isSearchable={false}
                            //value={(props?.props?.current_page_number) + 1}
                            components={{ DropdownIndicator: () => <i className="icon icon-select-dropdown-dark"></i>, IndicatorSeparator: () => null }}
                        />
                        <div className="spacing spacing-both">of</div>
                        <div className="spacing">{props?.nbPages}</div>
                    </div> */}

          <Col className="text-center col-8 pagination_dropdown">
            Page:
            <select
              id="pagination-select"
              className="pagination-select"
              onChange={changepagination}
            >
              {new Array(nbPages).fill(null).map((_, index) => {
                const page = index + 1

                const selectedValue = parseInt(currentPageNumber, 10) + 1
                return (
                  <option
                    value={page}
                    selected={selectedValue === page ? "selected" : ""}
                    key=""
                  >
                    {page}
                  </option>
                )
              })}
            </select>
            of {nbPages}
          </Col>

          <button
            className={`results-btn d-flex align-items-center ${
              currentPageNumber + 1 === nbPages ? "disabled" : ""
            }`}
            disabled={currentPageNumber + 1 === nbPages ? "disabled" : ""}
            onClick={() => nextpage()}
          >
            <span>Next</span> <i className="icon icon-next" />
          </button>
        </div>
      )}
    </div>
  )
}

export default SearchResultsPagination
